<section class="container">
<ng-container *ngIf="data">
  <section class="works-section">
    <h2 class="main-title" [innerHTML]="data.title"></h2>
    <h3 class="section-subtitle">{{ data.sectionSubTitle }}</h3>

    <div class="desktop-row">
      <!-- Preview -->
      <div class="desktop-col-left">
        <app-website-preview [website]="selectedWebsite"></app-website-preview>
      </div>

      <!-- Website List -->
      <div class="desktop-col-right">
        <!-- Desktop grid -->
        <div class="website-grid">
          <div class="website-grid-item" *ngFor="let site of websites; trackBy: trackById">
            <app-website-card
              [site]="site"
              [isActive]="site.id === selectedWebsite.id"
              (click)="selectWebsite(site)">
            </app-website-card>
          </div>
        </div>

        <!-- WhatsApp -->
        <div class="whatsapp-wrapper">
          <app-whatsapp-button
            class="work-btn"
            [buttonText]="'Get your website' | translate">
          </app-whatsapp-button>
        </div>
      </div>
    </div>
  </section>
</ng-container>
</section>